



































import { Component, Vue } from 'vue-property-decorator';
import { SearchMode } from '@/global.ts';

@Component
export default class Main extends Vue {
  private modeOptions: string[] = [SearchMode.user, SearchMode.repo];
  private searchMode: string = SearchMode.user;
  private keyWord: string = '';
  private searchRoute: string = '';

  private get limitExceeded(): boolean {
    return this.$store.state.requests.search.quantity === 0;
  }
}
